// Failsafe localStorage-backed draft persistence.
//
// All localStorage access in the app for in-progress text drafts goes through
// these helpers so the try/catch lives in exactly one place. None of these
// functions can throw: if localStorage is unavailable (private mode, quota
// exceeded, disabled), they silently no-op and return safe defaults. Drafts are
// advisory only — the server remains the source of truth.

/**
 * Build the storage key for a maintenance fault-description (vikakuvaus) draft.
 * Scoped by organization + maintenance so drafts never leak across orgs.
 * Returns null when either id is missing (callers treat null as "no draft").
 */
export function buildDescriptionDraftKey(orgId, maintenanceId) {
  if (!orgId || !maintenanceId) {
    return null;
  }
  return `verstaani_vikakuvaus_draft_${orgId}_${maintenanceId}`;
}

/**
 * Load and parse a draft. Returns the parsed object, or null on any problem
 * (missing key, empty value, malformed JSON, localStorage unavailable).
 */
export function loadDraft(key) {
  if (!key) {
    return null;
  }
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

/**
 * Persist a draft value (serialized as JSON). Failure is silently ignored.
 * Returns true on success, false otherwise (callers may ignore the result).
 */
export function saveDraft(key, value) {
  if (!key) {
    return false;
  }
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    return false;
  }
}

/** Remove a draft. Never throws. */
export function clearDraft(key) {
  if (!key) {
    return;
  }
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // ignore
  }
}
